module.exports = __webpack_public_path__ + "img/team-banner.c3080030.png";